// export const BASE_URL = 'http://localhost:3001/api/';
export const BASE_URL = 'https://api.process.afaqtel.ir/api/'
// export const STATIC_URL = 'http://localhost:3001/static/';
export const STATIC_URL = 'https://api.process.afaqtel.ir/static/'
export const PROCESS_URL = 'processes/';
export const ACCESS_URL = (id: string) => `processes/${id}/accesses`;
export const ACCESS_ALL_URL = (id: string) => `processes/${id}/all-accesses`;
export const STAGE_URL = 'stages/';
export const ORGANIZATION_URL = `${PROCESS_URL}organizations/`;
export const NOTE_URL = (id: string) => `${STAGE_URL}${id}/notes/`;
export const SUBMIT_URL = (id: string) => `${STAGE_URL}${id}/states/`;
export const STAGE_ATTACHMENT_URL = (id: string) => `${STAGE_URL}${id}/attachments/`;
export const STAGE_ACCESS_URL = (id: string) => `${STAGE_URL}${id}/accesses/`;
export const RECORD_URL = (id: string) => `${STAGE_URL}${id}/records/`;
export const ATTACHMENT_URL = (id: string) => `attachments/${id}/`;
export const LOGIN_URL = 'auth/login/';
export const PROFILE_URL = 'auth/profile/';
export const ACCOUNTS_URL = 'auth/accounts/';
export const REMOVE_ACCESS_URL = (id: string) => `${STAGE_URL}accesses/${id}`;
